module.exports = __webpack_public_path__ + "img/PEDRO_MAGALHAES.1bcaaa63.jpg";